<nav>
  <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
    <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
      *ngFor="let bread of JsonBreadcrumb; let last = last; let index = index; let first = first">

      <ng-container *ngIf="!last">
        <a [href]="first ? '/' : bread['@id']">
          {{ bread.name }}
        </a>
      </ng-container>

      <ng-container *ngIf="last">
        <span>{{ bread.name }}</span>
      </ng-container>

    </li>
  </ol>
</nav>